import React from "react"


const ImageHero = (props, {page}) => {
  return (
    <div className="image-hero">
      <video
      className="image-hero__bg-vid"
        loop
        autoPlay
        muted="true"
        playsInline="true"
        disablePictureInPicture="true"
      >
        {/* <source src={page.data.video.url} type="video/mp4" /> */}
        <source src={props.video} type="video/mp4" />
      </video>

      <div className="image-hero__content">
          <h1 className="image-hero__content-title">
          {props.title}</h1>
          {/* <p className="image-hero__content-text">{props.text}</p> */}

        {/* {props.donationForm === "true" && <DonateTabs />} */}
      </div>
    </div>
  )
}
export default ImageHero
